module.exports = __webpack_public_path__ + "img/jacket.f1329775.png";